// keyboardOffset computes how far above the layout-viewport bottom the floating
// key toolbar must sit so it rests directly on top of the on-screen keyboard.
//
// When the iOS soft keyboard opens, window.visualViewport shrinks while
// window.innerHeight (the layout viewport) stays the same. The gap between the
// layout viewport and the visual viewport's bottom edge — innerHeight minus the
// visual viewport's height and its offsetTop — is exactly the keyboard's height.
// With the keyboard closed that gap is 0, so the toolbar sits at the screen
// bottom. We clamp to 0 to guard against transient over-reports during the
// open/close animation.
export function keyboardOffset(v: {
  innerHeight: number;
  vvHeight: number;
  vvOffsetTop: number;
}): number {
  const off = v.innerHeight - v.vvHeight - v.vvOffsetTop;
  return off > 0 ? off : 0;
}
